/* RIFT // VOLT — overlays, AJAX cart drawer, live search */
(() => {
  const d = document, root = d.documentElement, RX = window.RX || {};
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => [...c.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const routes = Object.assign({ root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', suggest: '/search/suggest' }, RX.routes);

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = String(RX.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const v = (Number(cents) || 0) / 100;
    const n = (x, dec, th = ',', dp = '.') => {
      const p = x.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dp);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return n(v, 0);
      if (k === 'amount_with_comma_separator') return n(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return n(v, 0, '.', ',');
      return n(v, 2);
    });
  }
  RX.money = money;

  /* ---------- body lock + overlays ---------- */
  let lastFocus = null;
  const lock = (on) => root.classList.toggle('rx-lock', on);
  function openLayer(el, focusSel) {
    lastFocus = d.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock(true);
    const f = focusSel && $(focusSel, el);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.rx-drawer.is-open,.rx-search.is-open,.rx-menu.is-open')) lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* mobile menu */
  const menu = $('#rx-menu'), burger = $('[data-menu-toggle]');
  if (menu && burger) {
    burger.addEventListener('click', () => {
      const open = !menu.classList.contains('is-open');
      burger.setAttribute('aria-expanded', open);
      if (open) openLayer(menu, 'a'); else closeLayer(menu);
    });
    $$('a', menu).forEach((a) => a.addEventListener('click', () => { burger.setAttribute('aria-expanded', 'false'); closeLayer(menu); }));
  }

  /* ---------- cart ---------- */
  const ICON = {
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>'
  };
  const drawer = $('#rx-cart');
  const freeShip = drawer ? Number(drawer.dataset.freeShip || 0) : 0;
  const getCart = () => fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const imgUrl = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  function setCount(n, bump) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.toggle('has-items', n > 0);
      if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function renderCart(cart, bump) {
    setCount(cart.item_count, bump);
    if (!drawer) return;
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    $('[data-cart-n]', drawer).textContent = cart.item_count;
    const body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
    foot.hidden = cart.item_count === 0;
    let html = '';
    if (freeShip > 0 && cart.item_count > 0) {
      const left = freeShip - cart.total_price;
      const pct = clamp((cart.total_price / freeShip) * 100, 0, 100);
      html += `<div class="rx-ship"><span class="rx-mono">${left > 0 ? `${esc(money(left))} away from free shipping` : 'Free shipping unlocked ⚡'}</span><div class="rx-ship__bar"><span style="--p:${pct}%"></span></div></div>`;
    }
    if (!cart.item_count) {
      html = `<div class="rx-drawer__empty"><div><strong>Garage is empty</strong><p>Nothing in the cart yet.</p></div><a class="rx-btn rx-btn--volt" href="${esc(routes.root)}collections/all"><span class="rx-btn__label">Shop parts</span></a></div>`;
    } else {
      html += cart.items.map((it) => `
        <div class="rx-item">
          <a class="rx-item__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(imgUrl(it.image, 240))}" alt="${esc(it.product_title)}" width="80" height="80" loading="lazy">` : ''}</a>
          <div class="rx-item__info">
            <a class="rx-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${it.variant_title && !it.product_has_only_default_variant ? `<span class="rx-item__variant">${esc(it.variant_title)}</span>` : ''}
            <div class="rx-item__row">
              <div class="rx-qty rx-qty--sm">
                <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Decrease quantity">${ICON.minus}</button>
                <input type="number" value="${it.quantity}" min="0" data-line-input="${esc(it.key)}" aria-label="Quantity">
                <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Increase quantity">${ICON.plus}</button>
              </div>
              <span class="rx-price">${esc(money(it.final_line_price))}</span>
            </div>
            <button type="button" class="rx-remove" data-line="${esc(it.key)}" data-q="0">Remove</button>
          </div>
        </div>`).join('');
    }
    body.innerHTML = html;
  }
  async function changeLine(key, q) {
    drawer && drawer.classList.add('is-busy');
    try {
      const r = await fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) });
      renderCart(r.ok ? await r.json() : await getCart());
    } finally { drawer && drawer.classList.remove('is-busy'); }
  }
  async function add(fd) {
    const r = await fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
    const cart = await getCart();
    renderCart(cart, true);
    return cart;
  }
  const openCart = () => drawer && openLayer(drawer, '[data-cart-close]');
  if (drawer) {
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
      if (d.body.classList.contains('t-cart')) return;
      e.preventDefault(); openCart(); getCart().then((c) => renderCart(c));
    }));
    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', () => closeLayer(drawer)));
    drawer.addEventListener('click', (e) => {
      const b = e.target.closest('[data-line]');
      if (b) changeLine(b.dataset.line, Number(b.dataset.q));
    });
    drawer.addEventListener('change', (e) => {
      const i = e.target.closest('[data-line-input]');
      if (i) changeLine(i.dataset.lineInput, Number(i.value));
    });
  }

  d.addEventListener('submit', (e) => {
    const form = e.target;
    if (!drawer || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form), err = $('.rx-form-error', form);
    if (err) err.textContent = '';
    btn && btn.classList.add('is-loading');
    add(new FormData(form))
      .then(() => openCart())
      .catch((x) => { if (err) err.textContent = x.message; })
      .finally(() => btn && btn.classList.remove('is-loading'));
  });
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (!drawer) { location.href = routes.cart; return; }
    const fd = new FormData();
    fd.append('id', b.dataset.quickAdd);
    fd.append('quantity', '1');
    b.classList.add('is-loading');
    const prev = b.innerHTML;
    add(fd).then(() => {
      b.classList.add('is-done'); b.innerHTML = ICON.check;
      setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = prev; }, 1600);
      openCart();
    }).catch(() => { location.href = b.dataset.url || routes.cart; })
      .finally(() => b.classList.remove('is-loading'));
  });

  /* ---------- search overlay ---------- */
  const search = $('#rx-search');
  if (search) {
    const input = $('input[name="q"]', search), out = $('[data-search-results]', search);
    let timer = 0, ctrl = null;
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openLayer(search, 'input[name="q"]'); }));
    $$('[data-search-close]', search).forEach((b) => b.addEventListener('click', () => closeLayer(search)));
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const u = `${routes.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
          const j = await fetch(u, { signal: ctrl.signal }).then((r) => r.json());
          const items = (j.resources && j.resources.results && j.resources.results.products) || [];
          out.innerHTML = items.length
            ? `<p class="rx-search__hint rx-mono">${items.length} result${items.length > 1 ? 's' : ''}</p><div class="rx-sr">${items.map((p, i) => `
                <a href="${esc(p.url)}" style="animation-delay:${RM ? 0 : i * 40}ms">${p.image ? `<img src="${esc(imgUrl(p.image, 300))}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}</span><span class="rx-price">${esc(money(Math.round(parseFloat(p.price) * 100)))}</span></a>`).join('')}</div>`
            : `<p class="rx-search__hint rx-mono">No parts match “${esc(q)}”</p>`;
        } catch (x) { /* aborted */ }
      }, 220);
    });
  }

  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeLayer(search); closeLayer(drawer);
    if (menu && menu.classList.contains('is-open')) { burger.setAttribute('aria-expanded', 'false'); closeLayer(menu); }
  });
})();